var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-box"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/terms"}},[_vm._v("服务条款")])],1),_c('li',[_c('router-link',{attrs:{"to":"/privacy"}},[_vm._v("隐私条款")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }